
<div class="row">

<div class="col-md-12">
  <div class="card ">
    <div class="card-header ">
      <h5 class="card-title">Emails Behavior</h5>
      <p class="card-category">Send performance</p>
    </div>
    <div class="card-body "><div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;"><div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div></div>
    <!-- BODY-->  
    <div>
      <i *ngIf="isLoadingChart" class="fa fa-spinner fa-pulse fa-fw"></i>
      <div *ngIf="!isLoadingChart" style="display: block">
        <canvas baseChart
                [datasets]="barChartData"
                [labels]="barChartLabels"
                [options]="barChartOptions"
                [legend]="barChartLegend"
                [chartType]="barChartType">
        </canvas>
      </div>
    </div>

    <!-- BODY-->
    </div>
    <div class="card-footer ">
      <hr>
      <div class="stats">
        <i class="fa fa-history"></i> This chart represent only sent emails, not failed ones.
      </div>
    </div>
  </div>
</div>

</div>